export default __webpack_public_path__ + "static/media/Total_Storage.2d1561ae.png";